module.exports = {
	'customFolder.m4.m410140_browse': {
		'assessmentYear': '考核年度',
		'assessmentPeriod': '考核期間',
		'assessmentScore': '評核分數',
		'isItApproved': '是否通過',
		'through': '通過',
		'notPassed': '未通過',
		'assessmentType': '考核種類',
		'assessmentLevelRegulations': '評核等級規則',
		'assessmentLevel': '評核等級',
		'comment': '評語',
		'assessmentStage': '考核階段',
		'supervisorSName': '主管姓名',
		'assessmentPersonnel': '考核人員',
		'stageScore': '階段分數',
		'stageAssessmentLevelRules': '階段評核等級規則',
		'stageAssessmentLevel': '階段評核等級',
		'assessmentPlanName': '階段名稱',
		'nonEmployee': '非員工',
	},
	'customFolder.m4.m410140': {
		'assessmentManagementName': '考核管理名稱',
		'startOfTheYear': '年度起',
		'yearToDate': '年度迄',
	},
	'customFolder.service.m3.service-m310250': {
		'supervisorSAffiliatedCompany': '主管所屬公司',
		'theCompanyToWhichTheAssessor': '考核人員所屬公司',
		'staffPerformanceRecordDetails': '部屬績效紀錄明細表',
	},
};
